import { 
    LOG_OUT_USER,
    FETCH_EXPENSES,
    ADD_EXPENSE,
    UPDATE_EXPENSE,
    DELETE_EXPENSE
 } from "../../actions/actionTypes";


const fetchExpensesReducer = (expenses, payload) => {
    let newExpenses = { ...expenses };
    for(let expense of payload.expenses){
        newExpenses[expense.expenseId] = expense;
    }
    return newExpenses;
}

const addExpenseReducer = (expenses, payload) => {
    let newExpenses = {
        ...expenses,
        [payload.expense.expenseId]: {...payload.expense}
    };
    return newExpenses;
}

const updateExpenseReducer = (expenses, payload) => {
    let newExpenses = {
        ...expenses,
        [payload.expenseId]: {
            ...expenses[payload.expenseId],
            ...payload.expense
        }
    };
    return newExpenses;
}

const deleteExpenseReducer = (expenses, payload) => {
    let newExpenses = { ...expenses};
    delete newExpenses[payload.expenseId];
    return newExpenses;
}


const expensesReducer = (state={}, action) => {
    let expenses = state;
    if (action && action.payload && !action.errors && !action.payload.errors){
        switch(action.type){
            case FETCH_EXPENSES:
                return fetchExpensesReducer(expenses, action.payload);
            case ADD_EXPENSE:
                return addExpenseReducer(expenses, action.payload);
            case UPDATE_EXPENSE:
                return updateExpenseReducer(expenses, action.payload);
            case DELETE_EXPENSE:
                return deleteExpenseReducer(expenses, action.payload);
            case LOG_OUT_USER:
                return {};
            default:
                return expenses;
        }
    }
    return expenses;
}

export default expensesReducer;